import React, { MouseEvent } from 'react'
import { Box, Link, SxStyleProp } from 'rebass'
import noop from 'lodash/noop'
import { TextV2 as Text, ICMSTextV2Props } from '../Text/TextV2'
import { theme } from '../../../styles'

export enum actionButtonStyle {
  blackPrimary = 'blackPrimary',
  copperPrimary = 'copperPrimary',
  whitePrimary = 'whitePrimary',
  disabled = 'disabled',
}

export interface IActionButton {
  body: ICMSTextV2Props
  buttonStyle?: actionButtonStyle
  link?: string
  sx?: SxStyleProp

  onClick?(e: MouseEvent): void
}

export const ActionButton = ({
  body,
  buttonStyle = actionButtonStyle.blackPrimary,
  link,
  sx = {},
  onClick = noop,
}: IActionButton) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        ...theme.v2.buttonStyles.cta[buttonStyle],
        ...sx,
      }}
      onClick={onClick}
    >
      <Link href={link} target={'_blank'}>
        <Text
          tag={body.tag}
          textFontStyle={body.textFontStyle}
          textFontColor={body.textFontColor}
          sx={{
            fontSize: ['16px'],
            fontFamily: 'GrtskPetaSemi',
            lineHeight: ['22px'],
            letterSpacing: ['-0.16px'],
            padding: '10px 30px',
            ...(body.sx ? body.sx : {}),
          }}
        >
          {body.text}
        </Text>
      </Link>
    </Box>
  )
}
